import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import TopReassuranceBar from "@/components/TopReassuranceBar";
import SummerBanner from "@/components/SummerBanner";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";
import { useLang } from "@/context/LangContext";

const Layout = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="min-h-screen bg-[#F5F0EB] text-[#1A1A1A]">
      <TopReassuranceBar />
      <SummerBanner />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <ExitIntentPopup />
      <WhatsAppButton lang={lang} />
      <CookieBanner />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#F5F0EB",
            border: "1px solid #1A1A1A",
            borderRadius: "2px",
            fontFamily: "Outfit, sans-serif",
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
};

export default Layout;
